import type { FlowInfo, FlowStep } from "../types/flow";
import { isPlainObject } from "./StudioScreenRenderer.utils.data";

function isFlowStepLike(value: unknown): value is FlowStep {
 return isPlainObject(value) &&
 typeof value.type === "string" && value.type.trim().length >0;
}

export function adaptInlineFlow(triggerId: string, binding: unknown): FlowInfo | null {
 const fallbackId = triggerId.trim() ? triggerId.trim() : "inline.trigger";

 if (Array.isArray(binding)) {
 const steps = binding.filter(isFlowStepLike);
 if (steps.length ===0) return null;
 const [domain = fallbackId, name = ""] = fallbackId.split(".");
 return {
 id: fallbackId,
 domain,
 name,
 params: {},
 steps,
 callsOperations: [],
 callsFlows: [],
 triggeredByScreens: [],
 isStreaming: false,
 meta: {},
 sourcePath: "",
 };
 }

 if (isPlainObject(binding)) {
 if (Array.isArray(binding.steps)) {
 const steps = binding.steps.filter(isFlowStepLike);
 if (steps.length ===0) return null;
 const id = typeof binding.id === "string" && binding.id.trim()
 ? binding.id.trim()
 : fallbackId;
 const [domain = id, name = ""] = id.split(".");
 return {
 id,
 domain,
 name,
 params: {},
 steps,
 callsOperations: [],
 callsFlows: [],
 triggeredByScreens: [],
 isStreaming: false,
 meta: {},
 sourcePath: "",
 };
 }

 if (isFlowStepLike(binding)) {
 const [domain = fallbackId, name = ""] = fallbackId.split(".");
 return {
 id: fallbackId,
 domain,
 name,
 params: {},
 steps: [binding],
 callsOperations: [],
 callsFlows: [],
 triggeredByScreens: [],
 isStreaming: false,
 meta: {},
 sourcePath: "",
 };
 }
 }
 return null;
}